import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";

import {
    ErrorMessage,
    IconDetailDownloadContainer,
    MessageAndButtonContainer
} from "./styles";
import SecondaryContent from "./SecondaryContent";
import DownloadButtons from "./DownloadButtons";
import DownloadMessagePublicDomain from "./DownloadMessagePublicDomain";
import DownloadMessageCreativeCommons from "./DownloadMessageCreativeCommons";
import DownloadMessageRoyaltyFree from "./DownloadMessageRoyaltyFree";
import AttributionAreaBasic from "icons/AttributionBacklink/AttributionAreaBasic";

import { useViewport } from "js/hooks/useViewport";

import breakpoints from "core/breakpoints";

import { useAttributionBacklink } from "icons/AttributionBacklink/Context";

const IconDetailDownload = ({
    icon,
    onBack,
    isPublic = false,
    isBasic = false,
    isPro = false,
    isPurchased = false // if coming from the checkout page
}) => {
    // error messaging
    const [hasFailed, setHasFailed] = useState(false);
    const showError = useCallback(() => setHasFailed(true));
    const hideError = useCallback(() => setHasFailed(false));

    const {
        incrementDownloadCount: incrementBasicDownloadCount,
        downloadCount
    } = useAttributionBacklink();

    const handleDownloadSuccess = () => {
        isBasic && incrementBasicDownloadCount(true);
        hideError();
    };

    const handleDownloadFailure = () => {
        showError();
    };

    const errorMessageNew = (
        <ErrorMessage handleDismissClick={hideError}>
            Something went wrong. Please try again later.
        </ErrorMessage>
    );

    const { browserWidth } = useViewport();
    const onDesktop = browserWidth > breakpoints.tablet.px;

    const isRoyaltyFree = !isPublic && (isPro || isPurchased);
    let DownloadMessageNew = null;

    if (isPublic) {
        DownloadMessageNew = DownloadMessagePublicDomain;
    }

    if (isBasic) {
        DownloadMessageNew = DownloadMessageCreativeCommons;
    }

    if (isRoyaltyFree) {
        DownloadMessageNew = DownloadMessageRoyaltyFree;
    }

    return (
        <IconDetailDownloadContainer>
            <MessageAndButtonContainer>
                <DownloadMessageNew />
                <DownloadButtons
                    icon={icon}
                    showChangeSize={!isBasic}
                    handleDownloadSuccess={handleDownloadSuccess}
                    handleDownloadFailure={handleDownloadFailure}
                />
            </MessageAndButtonContainer>
            <AttributionAreaBasic onDesktop={onDesktop} />
            <SecondaryContent
                icon={icon}
                onBack={onBack}
                showBackLink={isBasic}
            />
            {hasFailed && errorMessageNew}
        </IconDetailDownloadContainer>
    );
};

IconDetailDownload.propTypes = {
    icon: PropTypes.object.isRequired,
    onBack: PropTypes.func,
    isPublic: PropTypes.bool,
    isBasic: PropTypes.bool,
    isPro: PropTypes.bool,
    isPurchased: PropTypes.bool
};

export default IconDetailDownload;
